import { IGetOrdemCompraAvaliacaoFornecedorUseCase } from "../../../presentation/useCases/read/get_ordem_compra_avaliacao_fornecedor_use_case";
import { AvaliacaoOrdemCompra } from "../../models/avaliacao_ordem_compra";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetOrdemCompraAvaliacaoFornecedorUseCase
 */

export class GetOrdemCompraAvaliacaoFornecedorUseCase implements IGetOrdemCompraAvaliacaoFornecedorUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getOrdemCompraAvaliacaoFornecedor(
    idOrdemCompra: number | undefined,
  ): Promise<AvaliacaoOrdemCompra> {
    if (idOrdemCompra === undefined) throw new Error('Falha ao obter id de ordem de compra!');
    const result = await this.repository.getOrdemCompraAvaliacaoFornecedor(idOrdemCompra);
    if (result === null) throw new Error('Falha ao buscar avaliação de ordem de compra!');
    return result;
  }
}
